/*
 * Copyright 2022 The Janus IDP Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const KEYCLOAK_HOST_ANNOTATION = 'keycloak.org/host';
export const KEYCLOAK_ID_ANNOTATION = 'keycloak.org/id';
export const KEYCLOAK_REALM_ANNOTATION = 'keycloak.org/realm';
export const KEYCLOAK_ENTITY_QUERY_SIZE = 100;
